import ErrorBoundaryView from "components/ErrorBoundaryView";
import { Provider } from "react-redux";
import { store } from "store";
import { QueryClient, QueryClientProvider } from "react-query";
import React, { Suspense } from "react";
import Bugsnag from "@bugsnag/js";
import { App } from "components/app/App";

// @ts-ignore
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const AppContainer = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryView}>
      <Provider store={store}>
        <QueryClientProvider client={new QueryClient()}>
          <Suspense><App /></Suspense>
        </QueryClientProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default AppContainer;
